// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2wFv2","button":"styles_button__1XN4C"};